<template>
    <v-container fluid>
      <v-card>
        <v-toolbar color="secondary" flat dense>
          <v-toolbar-title>New Payment Mode</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn text small to="/payment-modes">
            <v-icon left dark>mdi-keyboard-backspace</v-icon>Back
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <!-- editor -->
            <editor :initial="dataItem" @data="save"></editor>
          <!-- end -->
        </v-card-text>

        <snackbar ref="snackbar"></snackbar>
      </v-card>
    </v-container>
</template>

<script>
import Editor from '../_components/editor.vue';
import { mapGetters } from 'vuex';
export default {
  components: {
    Editor
  },
  computed: {
    ...mapGetters(['user'])
  },
  data: () => ({
    dataItem: {}
  }),
  methods: {
      save(data) {
      const url = "/payment-modes";
      const self = this;
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if(res.ResultCode == 1200) {
            self.$router.push("/payment-modes");
          }
          self.$store.commit("btnLoader", false);
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    }
  }
};
</script>